var render = function render(){var _vm=this,_c=_vm._self._c;return _c('testate',{attrs:{"filtraTipiDocumento":_vm.filtraTipiDocumento},on:{"apriDettaglio":_vm.apriDettaglio}})
}
var staticRenderFns = []

export { render, staticRenderFns }